import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB6KsEukf_ZCLihRGNIdHjxJsQa5zTIdj4",
    authDomain: "my-blog-project-78b84.firebaseapp.com",
    projectId: "my-blog-project-78b84",
    storageBucket: "my-blog-project-78b84.appspot.com",
    messagingSenderId: "531624482514",
    appId: "1:531624482514:web:17e25835a98587eb07ff0b",
    measurementId: "G-E57HREWSL0"
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
